module.exports = __webpack_public_path__ + "static/media/PingFangHK Regular-01.abc43bb7.svg";